const newRegisteredEmail = value => {
	return {
		type: "NEW_REGISTERED_EMAIL",
		data: value
	};
};

export default newRegisteredEmail;
